import React, { useContext, useMemo, useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip, Popover, Button } from 'antd'
import { faBell } from '@fortawesome/pro-solid-svg-icons'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'

import { getUser } from '../../reducers/UserReducer'
import { GlobalContext } from '../../Providers/GlobalProvider'
import { readAllUserMessages } from '../../utils/api/user'
import { TOOLTIP_TRIGGERS } from '../antd/antdHelper'
import { InternshipMessageContext } from '../../Providers/InternshipMessageProvider'
import { MACCS_CONTEXT } from '../../utils/constants'

import '../../assets/new-messages-notification.scss'
import { MaccsInternshipMessageContext } from '../../Providers/MaccsinternshipMessageProvider'
import { isObject } from '../../utils'

const mapStateToProps = state => ({ user: getUser(state.getUser), t: getTranslate(state.locale) })

const NewMessagesNotification = ({ t, user }) => {
  const { unreadMessages, setUnreadMessages } = useContext(GlobalContext)
  const im = useContext(InternshipMessageContext)
  const mim = useContext(MaccsInternshipMessageContext)

  const [loading, setLoading] = useState(false)
  const [totalMessagesUnread, setTotalMessagesUnread] = useState(0)

  const isMaccs = useMemo(() => MACCS_CONTEXT.includes(user.context), [user])
  const localUnreadMessages = useMemo(() => isMaccs ? totalMessagesUnread : unreadMessages, [isMaccs, totalMessagesUnread, unreadMessages])

  const markAllAsRead = async () => {
    setLoading(true)
    setUnreadMessages(0)
    setTotalMessagesUnread(0)

    readAllUserMessages(user).then(() => setLoading(false))
  }

  const toggleDisplayMessages = () => {
    if (isObject(mim)) {
      mim.setDisplay(!mim.display)
    } else {
      im.setDisplay(!im.display)
    }
  }

  return (
    <Popover
      placement='bottomLeft'
      trigger={localUnreadMessages === 0 ? TOOLTIP_TRIGGERS.CONTEXT_MENU : TOOLTIP_TRIGGERS.HOVER}
      content={(
        <Button
          loading={loading}
          onClick={markAllAsRead}
          type='primary'
        >
          {t('new_messages_notification.popover')}
        </Button>
      )}
    >
      <Tooltip placement='right' title={t('new_messages_notification.tooltip')} trigger={localUnreadMessages > 0 ? TOOLTIP_TRIGGERS.CONTEXT_MENU : TOOLTIP_TRIGGERS.HOVER}>
        <button
          className={`new-messages-notification-wrapper ${localUnreadMessages === 0 ? 'disabled' : ''}`}
          type='button' onClick={toggleDisplayMessages}
        >
          <FontAwesomeIcon icon={faBell} />
          {localUnreadMessages > 0 && <div className='unread-messages-bubble'>{localUnreadMessages > 99 ? '99+' : localUnreadMessages}</div>}
        </button>
      </Tooltip>
    </Popover>
  )
}

export default connect(mapStateToProps)(NewMessagesNotification)
